import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
type Purchase = {
  name: string;
  location: string;
  minutes: number;
};
const PURCHASES: Purchase[] = [{
  name: 'Valentina R.',
  location: 'Bogotá, Colombia 🇨🇴',
  minutes: 2
}, {
  name: 'Luis Fernando M.',
  location: 'Guadalajara, México 🇲🇽',
  minutes: 4
}, {
  name: 'Camila S.',
  location: 'Santiago, Chile 🇨🇱',
  minutes: 1
}, {
  name: 'Diego A.',
  location: 'Córdoba, Argentina 🇦🇷',
  minutes: 6
}, {
  name: 'Paola G.',
  location: 'Lima, Perú 🇵🇪',
  minutes: 3
}, {
  name: 'Gabriela T.',
  location: 'Quito, Ecuador 🇪🇨',
  minutes: 5
}, {
  name: 'Ricardo N.',
  location: 'Maracaibo, Venezuela 🇻🇪',
  minutes: 2
}, {
  name: 'Alejandra V.',
  location: 'San José, Costa Rica 🇨🇷',
  minutes: 7
}, {
  name: 'Manuel O.',
  location: 'Sevilla, España 🇪🇸',
  minutes: 3
}, {
  name: 'Daniela C.',
  location: 'Montevideo, Uruguay 🇺🇾',
  minutes: 4
}, {
  name: 'Héctor B.',
  location: 'Ciudad de Panamá, Panamá 🇵🇦',
  minutes: 8
}, {
  name: 'Lucía F.',
  location: 'Santo Domingo, Rep. Dominicana 🇩🇴',
  minutes: 2
}];
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeoutId: number;
    const cycle = (delay: number) => {
      timeoutId = window.setTimeout(() => {
        setVisible(true);
        timeoutId = window.setTimeout(() => {
          setVisible(false);
          setIndex(prev => (prev + 1) % PURCHASES.length);
          cycle(9000);
        }, 6000);
      }, delay);
    };
    cycle(6000);
    return () => window.clearTimeout(timeoutId);
  }, [dismissed, index]);
  if (dismissed) return null;
  const purchase = PURCHASES[index];
  return <AnimatePresence data-id="element-227" data-mp="23lda9weab01z">
      {visible && <motion.div initial={{
      opacity: 0,
      y: -16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: -12,
      scale: 0.96
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 26
    }} className="fixed left-3 right-3 top-3 z-50 sm:left-4 sm:right-auto sm:top-auto sm:bottom-24 sm:max-w-sm" role="status" aria-live="polite" data-id="element-228" data-mp="23kboawvqct5h">
          <div className="relative flex items-center gap-3 rounded-2xl border border-ofm-200 bg-white p-3 pr-9 shadow-xl" data-id="element-229" data-mp="2pl2e0z79dgn6">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-ofm-100" data-id="element-230" data-mp="1wx6b3cr3ishy">
              <CheckCircle2Icon className="h-6 w-6 text-ofm-600" aria-hidden="true" data-id="element-231" data-mp="21w9eksrfgqnt" />
            </div>
            <div className="min-w-0" data-id="element-232" data-mp="26mpvimugiuex">
              <p className="truncate text-[13px] font-bold text-ofm-900" data-id="element-233" data-mp="26nrjtt0hhdel">
                {purchase.name} acaba de comprar
              </p>
              <p className="truncate text-[12px] text-ofm-800/70" data-id="element-234" data-mp="195rem0m035em">
                Sistema de Decisión Clínica OFM
              </p>
              <p className="truncate text-[11px] font-medium text-ofm-600" data-id="element-235" data-mp="3rhghewjwjmvg">
                {purchase.location} · hace {purchase.minutes} min
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute right-2 top-2 rounded-md p-1 text-ofm-800/40 transition-colors hover:text-ofm-800" data-id="element-236" data-mp="3ig9zqk5io60m">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-237" data-mp="38k71vqhp6tjh" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}